/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Routes } from '@administration-client/shared';
import { User } from '@administration-client/user-shared';
import { ConvertForDataTestPipe, StateResource } from '@common/tech-shared';
import { Component, Input } from '@angular/core';
import { SpinnerComponent } from '@ods/component';
import { ListComponent, ListItemComponent, RoutingButtonComponent } from '@ods/system';
import { UserComponent } from './user/user.component';

@Component({
  selector: 'administration-user-list',
  templateUrl: './user-list.component.html',
  imports: [ListComponent, ListItemComponent, UserComponent, RoutingButtonComponent, SpinnerComponent, ConvertForDataTestPipe],
})
export class UserListComponent {
  @Input() usersStateResource: StateResource<User[]>;

  protected readonly routes = Routes;
}
